import {User, Device} from "../models";
import {APIError, APIVersion, AuthenticatedRequest, BasicRequest, HTTPMethod} from "../requests/request";
import {APIErrorType} from "../errors";
import { DeviceData } from "./devices";

export class LoginUserError extends Error {
    public type: LoginUserErrorType;
    public underlyingError: APIError;

    constructor(type: LoginUserErrorType, underlyingError: APIError) {
        super('User Login Error');
        this.type = type;
        this.underlyingError = underlyingError;
    }
}

export enum LoginUserErrorType {
    invalidLogin,
    userNotFound,
    unknownError
}

export class API {

    /**
     * Login the user
     * @param {string} email
     * @param {string} password
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    public static login(email: string, password: string, device: DeviceData): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/login', HTTPMethod.POST, APIVersion.v1_2, undefined, {
            email: email,
            password: password,
            device: device
        });

        return apiRequest.send(Device).then((response) => {
            return <Device>response.data
        }).catch((error: APIError) => {
            switch (error.type) {
                case APIErrorType.InvalidParameters:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case APIErrorType.InvalidLogin:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case APIErrorType.ResourceNotFound:
                    throw new LoginUserError(LoginUserErrorType.userNotFound, error);
                default:
                    throw new LoginUserError(LoginUserErrorType.unknownError, error);
            }
        })
    }

    /**
     * Registers a new facebook user with the provided data
     * @param {string} facebook_token
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    public static authenticateFacebookUser(facebook_token: string, device: DeviceData): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/login/facebook', HTTPMethod.POST, APIVersion.v1_2, undefined, {
            "facebook_token": facebook_token,
            "device": device
        });

        return apiRequest.send(Device).then((response) => {
            return <Device>response.data
        }).catch((error: APIError) => {
            switch (error.type) {
                case APIErrorType.InvalidParameters:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case APIErrorType.InvalidLogin:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case APIErrorType.ResourceNotFound:
                    throw new LoginUserError(LoginUserErrorType.userNotFound, error);
                default:
                    throw new LoginUserError(LoginUserErrorType.unknownError, error);
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/api/src/endpoints/login.ts